import type React from 'react';
import MarketPreviews from 'app/shared/components/MarketPreviews';
import type { Market } from 'app/shared/types/Market';

interface NearbyAreaTrendsProps {
  areaName: string | null;
  nearbyAreaTrends: Array<Market>;
  isSmallScreen: boolean;
  isMobile: boolean;
}

const NearbyAreaTrends: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<NearbyAreaTrendsProps>>
> = (props) => {
  const { areaName, nearbyAreaTrends, isSmallScreen, isMobile } = props;

  const heading = isMobile ? `Rent trends nearby` : `Rent trends near ${areaName}`;

  return (
    <MarketPreviews
      markets={nearbyAreaTrends}
      heading={heading}
      subject="nearby areas"
      isSmallScreen={isSmallScreen}
      isMobile={isMobile}
    />
  );
};

export default NearbyAreaTrends;
